
import { useState,useEffect } from 'react';
import { useNavigate,useSearchParams,createSearchParams } from 'react-router-dom';
import '../App.css';
import './css/drmohan-style.css'
import './css/drmohan-theme16.css'
import './css/bootstrap.min.css'
import './css/fontawesome-all.min.css'
import logo from './images/logo.png'
import drmohan from './images/globe.png'
import graphic3 from './images/graphic3.svg'
import placeholder from './images/placeholder.png'
import DatePicker from 'react-datepicker';
import { subDays,addDays } from 'date-fns';
import 'react-datepicker/dist/react-datepicker.css'
import * as moment from 'moment';
import axios from "axios";
import * as Yup from "yup";
import { Formik } from "formik"
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";



function Home() {
const [formData, setFormData] = useState({
  txtSearch: '',
  OTP: '',
});


const getMinDate = () => {
  const date = new Date();
  date.setDate(date.getDate() + 2); // next 2nd day
  return date;
};

const getMaxDate = () => {
  const date = new Date();
  date.setDate(date.getDate() + 45); // limit 45 days
  return date;
};

const[place,setPlace] = useState([]);
const [mobileErr, setMobileErr] = useState(false);
const [mobileErrMsg, setMobileErrMsg] = useState("");
const[vslist,setVstList] = useState([]);
const[existname,setExistname] = useState([]);
const[datepick,selectdatePick] = useState(new Date());
const[city,setCity] = useState([]);
const[numbererr, setNumbererr] = useState(false)
const[patnameerr, setPatnameerr] = useState(false)
const[ageerr, setAgeerr] = useState(false)
const[emaileerr, setEmailerr] = useState(false)
const[emaileerrinput, setEmailerrinput] = useState(false)
const[emaileerrmsg, setEmailerrmsg] = useState("")
const[dateeerr, setDateerr] = useState(false)
const[commenteerr, setCommenterr] = useState(false)
const[backtrigger, setbacktrigger] = useState(false)
const[otperr, setOTPerr] = useState(false)
const[doctor,setDoctor] = useState([]);
const[datedoc,setDateDoc] = useState([]);
const[datedoc1,setDateDoc1] = useState([]);

const[showdocid,setShowDocId] = useState("");
const[locationgetid,setlocationgetid] = useState("");
const[doctorgetid,setdoctorgetid] = useState("");
const[showdocname,setShowDocName] = useState("");
const [getotp, setgetotp] = useState("");
const[showdocnimg,setShowDocImg] = useState("");
const[statename,setstatename] = useState("");
const[branch,setbranch] = useState("");
const[locidname,setlocidname] = useState("");
const [showOTP, setshowOTP] = useState(false);
const [existpatient, setexistPatient] = useState(false);
const [stepone, setstepOne] = useState(true)
const [steptwo, setstepTwo] = useState(false)
const [steptwoexist, setstepTwoExist] = useState(false)
const [steptwosub, setstepTwoSub] = useState(false)
const [steptwosubdoct, setstepTwoSubDoc] = useState(false)
const [showsuccess,setShowSuccess] = useState(false)
const [stepthree, setstepThree] = useState(false)
const [startDate, setStartDate] = useState(new Date())

const navigate = useNavigate();
const [searchParams] = useSearchParams();

// const makeYear = searchParams.set("CampName","App");
const [formBook, setFormBook] = useState({

  LocID:"",
  PatName:"",
  Age:"",
  Mobile:"",
  Gender:"M",
  New_CallBack:"New",
  Channel:"Web-Apt",
  Query:"",
  Email:""
  
  });
  const backToMRNList = () => {
    setstepThree(false);
    setstepTwoExist(true);
    setexistPatient(false);   // optional, but keeps flow clean
  };
  
  // function validate(values) {
  //   let errors = {};
  //   if (inputValues.email.length < 15) {
  //     errors.email = "Email is too short";
  //   }
  //   if (inputValues.password.length < 5) {
  //     errors.password = "Password is too short";
  //   }
  //   if (!inputValues.age || inputValues.age < 18) {
  //     errors.age = "Minimum age is 18";
  //   }
  //   return errors;
  // }

const backtoselect = () =>{
  setbacktrigger(true)
  // setexistPatient(false)
     setstepOne(false)
      setstepTwo(true)
      setstepThree(false)
      navigate({
        pathname: "/",
        // search: createSearchParams({
        //     CampName: "registered"
        // }).toString()
    });
}

useEffect(() => {
//   navigate({
//     pathname: "/",
//     search: createSearchParams({
//         CampName: "registered"
//     }).toString()
// });
  console.log(searchParams.get("CampName"),"useSearchParams")
  setStartDate(date => {
    date.setDate(date.getDate() + 3);
    return new Date(date)
});
  const notAvailableDays = [1,2,6];

  const isDisabled = (date) => {
     const day = date.getDay(date);
     return notAvailableDays.includes(day);
  }
    axios({
        method: 'get',
        url: 'https://drmohansdiabetes.co.in/telebookingAPI/api/GetClusterList',})
        .then(response => {
          setPlace(response.data.ClusterLst)
          console.log(response.data.ClusterLst)})
        .catch(error => {
          throw error;
        });
        
}, [])
const validateEmail = (email) => {

  const mobile = localStorage.getItem("MobileNumber");

if (!mobile || mobile.length === 0) {
  setMobileErr(true);
  setMobileErrMsg("Mobile number is required");
  return;
}

if (!/^[6-9]\d{9}$/.test(mobile)) {
  setMobileErr(true);
  setMobileErrMsg("Enter a valid 10-digit mobile number");
  return;
}

setMobileErr(false);
// custom email regex
  const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  if (!email || email.length === 0) {
    setEmailerrinput(true)
    setEmailerrmsg('Email is required')

  }

   if (!regex.test(email)) {
    setEmailerrinput(true)
    setEmailerrmsg( 'Invalid email format')
  }

  // other custom validations...
  
  
}
const handleChange = (e)=>{
selectdatePick(e.target.value)
}
const backtocluster = ()=>{
  setstepOne(false)
  setstepTwo(true)
  setstepTwoSub(false)

}
const backtobranch = () =>{
  setstepTwoSub(true)
  // setstepTwoSubDoc(true)
  setstepTwoSubDoc(false)
}
const FormSubmit = () => {

  const emailRegex =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  /* =========================
     VALIDATION START
  ========================== */

  // Patient Name
  if (!existpatient && (!formBook?.PatName || formBook.PatName.trim() === "")) {
    setPatnameerr(true);
    setAgeerr(false);
    setEmailerr(false);
    setDateerr(false);
    setCommenterr(false);
    return;
  }

  // Age
  if (!formBook?.Age || formBook.Age.trim() === "") {
    setPatnameerr(false);
    setAgeerr(true);
    setEmailerr(false);
    setDateerr(false);
    setCommenterr(false);
    return;
  }

  // Email empty
  if (!existpatient && (!formBook?.Email || formBook.Email.trim() === "")) {
    setPatnameerr(false);
    setAgeerr(false);
    setEmailerr(true);
    setEmailerrmsg("Email is required");
    setDateerr(false);
    setCommenterr(false);
    return;
  }

  // Email invalid
  if (!existpatient && !emailRegex.test(formBook.Email)) {
    setPatnameerr(false);
    setAgeerr(false);
    setEmailerr(true);
    setEmailerrmsg("Invalid email format");
    setDateerr(false);
    setCommenterr(false);
    return;
  }

  // Appointment Date (IMPORTANT FIX)
  if (!startDate || !(startDate instanceof Date)) {
    setPatnameerr(false);
    setAgeerr(false);
    setEmailerr(false);
    setDateerr(true);
    setCommenterr(false);
    return;
  }

  // Comments
  if (!formBook?.Query || formBook.Query.trim() === "") {
    setPatnameerr(false);
    setAgeerr(false);
    setEmailerr(false);
    setDateerr(false);
    setCommenterr(true);
    return;
  }

  // Clear all errors
  setPatnameerr(false);
  setAgeerr(false);
  setEmailerr(false);
  setDateerr(false);
  setCommenterr(false);

  /* =========================
     FORM SUBMISSION START
  ========================== */

  console.log("Submitted formBook:", formBook);

  const getmrno = localStorage.getItem("mrno");
  const getdob = localStorage.getItem("dob");
  const campname = localStorage.getItem("CampName");

  const payload = {
    ...formBook,
    Mobile: localStorage.getItem("MobileNumber"),
    Query:
      formBook.Query +
      " - Booked on Date: " +
      moment(startDate).format("DD/MM/YYYY"),
    LocID: locidname,
    CampName: campname !== null ? campname : "registered",
    AppDate: moment(startDate).format("MM/DD/YYYY"),
  };

  if (getmrno) {
    payload.MRNo = getmrno;
    payload.DOB = moment(getdob).format("MM/DD/YYYY");

    if (!backtrigger) {
      payload.DrID = doctorgetid;
      payload.LocID = locationgetid;
    } else {
      payload.DrID = showdocid;
      payload.LocID = locidname;
    }

    payload.PatName = vslist?.PatName;
    payload.Email = formBook?.Email;
  }

  axios({
    method: "post",
    url: !getmrno
      ? "https://drmohansdiabetes.co.in/TeleBookingAPI/api/PatientRegister"
      : "https://drmohansdiabetes.co.in/TeleBookingAPI/api/ReviewPatientRegister",
    data: payload,
  })
    .then((response) => {
      console.log(response);
      setShowSuccess(true);

      localStorage.removeItem("MobileNumber");
      localStorage.removeItem("mrno");
      localStorage.removeItem("dob");

      setTimeout(() => {
        window.location.reload();
        localStorage.removeItem("CampName");
      }, 5000);
    })
    .catch((error) => {
      console.error("Appointment booking failed:", error);
    });
};

    
const getOTP=(event)=>{
  if(formData.txtSearch.length === 10){

  setshowOTP(true)
  setNumbererr(false)
  event.preventDefault();

  axios.post(`https://drmohansdiabetes.co.in/TeleBookingAPI/api/SendTeleOTP?mobile=${formData.txtSearch}`, {
  })
  .then((response) => {
    // alert(response.data.OTP)
  
    localStorage.setItem("MobileNumber",formData.txtSearch)
    localStorage.setItem("CampName", searchParams.get("CampName"))
    localStorage.removeItem("mrno")
    localStorage.removeItem("dob")
    console.log(response.data.OTP);
    setgetotp(response.data.OTP)
    navigate({
      pathname: "/",
      // search: createSearchParams({
      //     CampName: "registered"
      // }).toString()
  });
    // if(response.data.OTP === formData.OTP){
    //   setstepOne(false)
    //   setstepTwo(true)
    //   navigate('/');
    // }else{
    //   setOTPerr(true)
    // }
  })
    
  }else{
    setNumbererr(true)
  }
}
const handleInputChange = (event) => {
  const { name, value } = event.target;
  setFormData((prevData) => ({
    ...prevData,
    [name]: value,
  }));
};
const handleFormChange = (event) => {
  const { name, value } = event.target;
  setFormBook((prevData) => ({
    ...prevData,
    [name]: value,
  }));

};
// const updateItem = (event) => {
//   const { name, value } = event.target;
//   setFormBook((prevData) => ({
//     ...prevData,
//     [name]: value,
//   }));
// };
const movesteptwosub= (data) =>{
  // alert(data)
  setstatename(data)
  axios({
    method: 'get',
    url: `https://drmohansdiabetes.co.in/TeleBookingAPI/api/GetTeleBranchList?cluster=${data}`,})
    .then(response => {
      setCity(response.data.brnLst)
      console.log(response.data.brnLst)})
     
    .catch(error => {
      throw error;
    });
    setstepTwo(false)
    setstepTwoSub(true)
}
const movesteptwosubdoct = (data, name) => {
  setlocidname(data);
  setbranch(name);

  axios({
    method: "post",
    url: `https://drmohansdiabetes.co.in/TeleBookingAPI/api/GetTeleDrList?LOCID=${data}`,
  })
    .then((response) => {
      const doctorList = response?.data?.drLst || [];

      if (doctorList.length > 0) {
        // Doctors available
        setDoctor(doctorList);
        setstepTwoSub(false);
        setstepTwoSubDoc(true);
      } else {
        // No doctors available
        setDoctor([]);
        alert("No doctors available for the selected branch.");
        // stay on same page OR redirect as needed
        setstepTwoSub(true);
        setstepTwoSubDoc(false);
      }
    })
    .catch((error) => {
      console.error("Doctor list fetch error:", error);
      alert("Unable to fetch doctor list. Please try again.");
    });
};

const movetoappointment = (mrno,dob) =>{
  localStorage.setItem("mrno",mrno)
  localStorage.setItem("dob",dob)
  let data = {
    "MrNo":mrno,
    "channel":"DMDSC",
    }
  let token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJWaWpheSIsImp0aSI6IjU1MWMyNGE1LWVhYjctNDg1Ni05ZGI0LWI5ZWIzMDVlZDhmNyIsImV4cCI6MTcyMzI4NDg0MywiaXNzIjoiaHR0cDovL2xvY2FsaG9zdCIsImF1ZCI6Imh0dHA6Ly9sb2NhbGhvc3QifQ.1U4_hhDoM8VaIaeMSZ9Tb7eym-bNUzWGvdq7yQ7yEK4'
  axios({
    method: 'post',
    url: `https://drmohansdiabetes.co.in/TeleBookingAPI/api/GetLastVisit`,data})
    .then(response => {
      setVstList(response?.data?.VstLst[0])
      setFormBook({Email:response?.data?.VstLst[0].Email})
      setlocationgetid(response?.data?.VstLst[0].LocID)
      setdoctorgetid(response?.data?.VstLst[0].DrID)
      setstepTwoExist(false)
      setexistPatient(true)
      setstepThree(true)
      getexistdoctorsche(response?.data?.VstLst[0].DrID,response?.data?.VstLst[0].LocID)
    })

}
const getexistdoctorsche = (drid, locid) => {
  const data = {
    DrID: drid,
    LocID: locid,
    TYPE: "C",
  };

  axios({
    method: "post",
    url: `https://drmohansdiabetes.co.in/TeleBookingAPI/api/GetLeaveDateList`,
    data,
  })
    .then((response) => {
      // ✅ SAFETY: force array
      const arrayOfObjects = Array.isArray(response?.data?.List)
        ? response.data.List
        : [];

      // ✅ Safe map
      const arrayOfDates = arrayOfObjects.map(
        (obj) => new Date(obj.Date)
      );

      setDateDoc1(arrayOfDates);
    })
    .catch((error) => {
      console.error("Doctor schedule fetch failed:", error);
      setDateDoc1([]); // prevent future crashes
    });
};

const bookdoctor = (drname, drid, locid, drimage) => {
  setShowDocName(drname);
  setShowDocId(drid);
  setShowDocImg(drimage);

  const data = {
    DrID: drid,
    LocID: locid,
    TYPE: "C",
  };

  axios({
    method: "post",
    url: `https://drmohansdiabetes.co.in/TeleBookingAPI/api/GetLeaveDateList`,
    data,
  })
    .then((response) => {
      const arrayOfObjects = Array.isArray(response?.data?.List)
        ? response.data.List
        : [];

      const arrayOfDates = arrayOfObjects.map(
        (obj) => new Date(obj.Date)
      );

      setDateDoc1(arrayOfDates);
    })
    .catch((error) => {
      console.error("Doctor leave fetch error:", error);
      setDateDoc1([]);
    });

  setstepTwoSubDoc(false);
  setstepThree(true);
};

const handleSubmit = () => {
if(formData.OTP.length === 4) {
      setOTPerr(false)

      if(getotp === formData.OTP){
        // setstepOne(false)
        // setstepTwo(true)
        checkexist()
        // navigate('/');
      }else{
        setOTPerr(true)
      }
  console.log('Submitted data:', formData);
  }else{
    setOTPerr(true)
  }
};

const checkexist = () =>{
  let token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJWaWpheSIsImp0aSI6IjU1MWMyNGE1LWVhYjctNDg1Ni05ZGI0LWI5ZWIzMDVlZDhmNyIsImV4cCI6MTcyMzI4NDg0MywiaXNzIjoiaHR0cDovL2xvY2FsaG9zdCIsImF1ZCI6Imh0dHA6Ly9sb2NhbGhvc3QifQ.1U4_hhDoM8VaIaeMSZ9Tb7eym-bNUzWGvdq7yQ7yEK4'
  axios({
    method: 'post',
    url: `https://drmohansdiabetes.co.in/TeleBookingAPI/api/GetInfobyMobMrn?mobile=${localStorage.getItem('MobileNumber')}`})
    .then(response => {
      // setDoctor(response.data.drLst)
      console.log(response.data.length)
      setExistname(response.data)
    if(response.data.length === 0){
        setstepOne(false)
        setstepTwo(true)
        navigate({
          pathname: "/",
          // search: createSearchParams({
          //     CampName: "registered"
          // }).toString()
      });
    }else{
      setstepTwoExist(true)

      setstepOne(false)
      navigate({
        pathname: "/",
        // search: createSearchParams({
        //     CampName: "registered"
        // }).toString()
    });
    }
    })
       

    .catch(error => {
      throw error;
    });
}

  return (
    <div className="App">
      <>
  <div className="form-body without-side">
    <div className="website-logo">
      <a >
        <div className="logo">
          <img className="logo-size" src={logo} alt="" />
        </div>
      </a>
      <a href='https://drmohans.com/' className='web-link' target='_blank'> <img src={drmohan} alt="" /> HOME</a>
    </div>
    <div className="row">
      <div className="img-holder">
        <div className="bg" />
        <div className="info-holder">
          <img src={graphic3} alt="" />
        </div>
      </div>
      <div className="form-holder">
        <div className="form-content">
          <section className="signup-step-container">
            <div className="container">
              <div className="row d-flex justify-content-center">
                <div className="col-md-12">
                  <div className="wizard">
                    <div className="wizard-inner">
                      <div className="connecting-line" />
                      <ul className="nav nav-tabs" role="tablist">
                        <li role="presentation" className={stepone?"active":"disabled"}>
                          <a                          >
                            <span className="round-tab">1 </span>
                            <i>Step 1</i>
                          </a>
                        </li>
                        <li role="presentation" className={steptwo || steptwosub || steptwosubdoct || steptwoexist ?"active":"disabled"}>
                          <a>
                            <span  className="round-tab">2</span> <i>Step 2</i>
                          </a>
                        </li>
                        <li role="presentation" className={stepthree?"active":"disabled"}>
                          <a>
                            <span className="round-tab">3</span> <i>Step 3</i>
                          </a>
                        </li>
                      </ul>
                    </div>
                   <div className="tab-content" id="main_form">
                        { stepone? <div
                          className="tab-pane active"
                          role="tabpanel"
                          id="step1"
                        >
                          <div className="form-items">
                            <h3>Appointment Submission</h3>
                            <input
                             type="text"
                             name="txtSearch"
                             maxLength={10}
                             value={formData.txtSearch}
                             required
                             autoComplete='off'
                             onChange={handleInputChange}
                             placeholder="Mobile Number"
                            className="form-control"
                            
                            />
                            {numbererr?<div className='errorshow'>Enter your Mobile Number</div>:<></>}
                           {showOTP? <input
                             type="text"
                             maxLength={4}
                             name="OTP"
                             value={formData.OTP}
                             onChange={handleInputChange}
                             placeholder="OTP"
                              className="form-control"
                            
                            />:null}
                           {otperr? <div className='errorshow'>Enter valid OTP</div>:<></>}
                           
                            <div className="info-content">
                              <span>
                                The form below is only a requistion for
                                appointment.
                              </span>
                              <span>
                                Kindly await an email/telephonic response from
                                us to confirm the status of your request.
                              </span>
                              <span>
                                Please plan/schedule your visit only on our
                                confirmation of your date/time of your
                                appointment.
                              </span>
                              <span>
                                For more information on appointment please call
                                044-43968888
                              </span>
                            </div>
                            <div className="form-button">
                               {!showOTP? <button  onClick={getOTP}
                                  id="submit"
                                  className="default-btn  ibtn"
                                >
                                  Get OTP
                                </button>:<button onClick={handleSubmit} type="submit"
                                  id="submit"
                                  className="default-btn  ibtn"
                                >
                                  Register
                                </button>}
                              </div>
                          </div>
                        </div>:steptwo && !stepone?<div className="form-items tab-bottom w-800">
                            <h3>Choose the Branch for Booking Appointment</h3>
                              <div className="location-item">
                              
                                <ul className="location-list" >
                                {place.map((data,index) => ( 
                                <li key ={index}>
                                    <a  onClick={() => movesteptwosub(data.Cluster)}>
                                      <span className="location-icon">
                                        <img src={data.ClustImage} />
                                      </span>
                                      <label htmlFor="">{data.Cluster}</label>
                                    </a>
                                  </li>
                                  ))}
                                
                                 
                                </ul>
                                
                              </div>
                        
                          </div>:steptwoexist && !stepone?<div className="form-items tab-bottom w-800">
                            <h3>Select the Patient Details to Book The Appointment</h3>
                              {/* <div className="location-item">
                              
                              <ul className="location-list" >
                                {existname.map((data,index) => ( 
                                <li key ={index}>
                                    <a  onClick={() => movetoappointment(data.Mrno)}>
                                      <span className="location-icon">
                                        <img src={data.Gender} />
                                      </span>
                                      <label htmlFor="">{data.Mrno}</label>
                                      <label htmlFor="">{data.Name}</label>
                                    </a>
                                  </li>
                                  ))}
                                
                                 
                                </ul>
                                <div class="form-items w-600">
                            <h3>Select the Patient Details to Book The Appointment</h3>
                            <form> */}
                              <div className="patient-details-list">
                                <ul className="patient-lists">
                                  {existname.map((data,index) => ( 
                                  <li key ={index} >
                                    <a onClick={() => movetoappointment(data.Mrno,data.DOB)}>
                                      <div className="name-start">{data.Name.substring(0, 1)}</div>
                                      <div className="name-details">
                                        <p>{data.Mrno}</p>
                                        <p>{moment(data.DOB).format('DD/MM/YYYY')}</p>
                                        <p>{data.Name}</p>
                                      </div>
                                      <div className="name-icon">  <img src={data.Gender} /></div>
                                      </a>
                                  </li>                                  ))}
                                </ul>
                              </div>
                            {/* </form> */}
                          {/* </div> */}
                              {/* </div> */}
                        
                          </div>:null}
                        {/* </form> */}
                        {steptwosub?<div class="form-items tab-bottom w-800">
                          <button  onClick={backtocluster} class="back-btn"><svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d='M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z'/></svg> Back</button>
                        <h3>Welcome to Our {statename} Branches</h3>
                        <label for="" class="sub-title">Choose any one of the Branch for your convenience</label>
                        <form>
                          <div class="location-item">
                            <ul class="location-list">
                            {Array.isArray(city) && city.map((data, index) => (
                              <li key ={index}>
                                <a  onClick={() => movesteptwosubdoct(data.LocName,data.LocID)}>
                                  <span class="location-icon"><img src={data.ImgUrl}/></span>
                                  <label for="">{data.LocID}</label>
                                </a>
                              </li>
                                 ))}
                            </ul>
                          </div>
                        </form>
                      </div> :null}
                     { steptwosubdoct?<div class="form-items tab-bottom w-1400">
                     <button onClick={backtobranch} class="back-btn"><svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d='M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z'/></svg> Back</button>
                      <h3>Please select the Doctor to Fix the Appointment</h3>
                      <form>
                        <div class="location-item ">
                        <ul class="location-list doctor-list">
                        {doctor.map((data,index) => ( 
                            <li key={index} >
                              <a onClick={() => bookdoctor(data.DrName,data.DrID,data.LocID,data.ImgURL)}>
                                <span class="location-icon"><img src={data.ImgURL}/></span>
                                <label for="">{data.DrName}</label>
                              </a>
                            </li>
                        ))}
                            
                          </ul>

                        </div>
                        
                        
                      </form>
                    </div>:null}
                    {stepthree ?
                          <div className="form-items tab-bottom w-800">
                            {!showsuccess?<>
                            <h3>Patient Registration</h3>
                            <div className="doctor-details">
                              <div className="patient-new">
                              {existpatient? <button className='change-btn' onClick={backtoselect}>
                                <div className='change-location'>
                                <img className="placeholder-icon" src={placeholder} alt="" />
                                  <span>Change Location</span>
                                </div>
                              </button>:null}
                                {/* <label htmlFor="" className="new-patient">
                                  New
                                </label>
                                <p>
                                  <b>Next Review Date:</b> Unregistered
                                </p> */}
                                <p>
                                  <b>Branch:</b> {existpatient&& !backtrigger?vslist.LocName:branch}
                                </p>
                                <p>
                                  <b>Location:</b> {existpatient&& !backtrigger?vslist.State:statename}
                                </p>
                              </div>
                              <div className="doctor-name">
                                <img
                                  src={existpatient && !backtrigger?vslist.DrImgUrl:showdocnimg}
                                  alt=""
                                />
                                <h4><b>Name:</b> {existpatient && !backtrigger?vslist.DrName:showdocname}</h4>
                              </div>
                            </div>
                            <h3>Provide Details to Book Appointment</h3>
                     
                              <div className="form-list">
                                <label>Patient Name</label>
                                {existpatient && setbacktrigger?<input
                                  className="form-control"
                                  type="text"
                                  name="PatName"
                                  // disabled
                                  defaultValue={vslist?.PatName}
                                  onChange={handleFormChange}
                                  placeholder="Enter your name"
                                />:
                                <input
                                className={`form-control ${patnameerr ? "error" : ""}`}
                                type="text"
                                name="PatName"
                                value={formBook.PatName}
                                onChange={handleFormChange}
                              />
                              }
                            {!existpatient&&patnameerr?<div className='errorshow'>Enter your Name</div>:<></>}

                              </div>
                              <div className="form-list">
                                <label>Age</label>
                                <input
  className={`form-control ${ageerr ? "error" : ""}`}
  type="text"
  name="Age"
  value={formBook.Age}
  onChange={handleFormChange}
/>

                            {ageerr?<div className='errorshow'>Enter your Age</div>:<></>}

                              </div>
                              <div className="form-list">
                                <label>Mobile Number</label>
                                <input
  className={`form-control ${mobileErr ? "error" : ""}`}
  type="text"
  name="Mobile"
  disabled
  value={localStorage.getItem('MobileNumber')}
  placeholder="Enter your Mobile Number"
/>

{mobileErr && (
  <div className="errorshow">{mobileErrMsg}</div>
)}

                                <div className="form-list">
                                <label>Mail ID</label>
                            {!existpatient&& emaileerrinput?<div className='errorshow'>{emaileerrmsg} </div>:<></>}

                                <input
                                  className="form-control"
                                  // onInput={validateEmail(formBook.Email)}
                                  type="text"
                                  name="Email"
                                  // defaultValue={existpatient?vslist.Email:formBook.Email}
                                  value={formBook.Email}
                                  onChange={handleFormChange}
                                  placeholder="Enter your mail id"
                                  required=""
                                />
                              
                                {!existpatient&& emaileerr?<div className='errorshow'>{emaileerrmsg} </div>:<></>}

                              </div>
                              <div className="form-list">
  <label>Book Appointment Date</label>

  <Flatpickr
    className="form-control"
    value={startDate}
    options={{
      dateFormat: "d/m/Y",
      minDate: getMinDate(),
      maxDate: getMaxDate(),
      disable: [
        function (date) {
          // Disable Sunday
          return date.getDay() === 0;
        },
      ],
    }}
    onChange={(date) => setStartDate(date[0])}
  />

  {dateeerr && (
    <div className="errorshow">Select a valid appointment date</div>
  )}
</div>


                              {/* <div className="form-list">
                                <label>Book Appointment Date</label>
                                <input
                                  className="form-control"
                                  type="date"
                                  minDate={new Date()}
                                  name=""
                                  value={datepick}
                                  onChange={handleChange}
                                  // onChange={handleFormChange}
                                  required=""
                                />
                              </div> */}
                              <div className="form-list">
                                <label>Comments</label>
                                <textarea
                                  name="Query"
                                  id=""
                                  value={formBook.Query}
                                  onChange={handleFormChange}
                                  cols={10}
                                  rows={2}
                                  defaultValue={""}
                                />
                            {commenteerr?<div className='errorshow'>Enter your comments </div>:<></>}

                              </div>
                              </div>
                              
                              
                              <div className="form-button">
                                {/* <button
                                  type="button"
                                  className="default-btn prev-step"
                                 
                                >
                                  Back
                                </button> */}
                                <div className="form-button d-flex gap-2">
  
  {/* Previous Button */}
  <button
    type="button"
    className="default-btn prev-step ibtn"
    onClick={backToMRNList}
  >
    Previous
  </button>

  {/* Book Appointment Button */}
  <button
    id="submit"
    type="submit"
    className="default-btn next-step ibtn"
    onClick={FormSubmit}
  >
    Book Appointment
  </button>

</div>

                            </div>
                            </>:
                            <div class="success-message">
                                  <svg viewBox="0 0 76 76" class="success-message__icon icon-checkmark">
                                      <circle cx="38" cy="38" r="36"/>
                                      <path fill="none" stroke="#FFFFFF" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M17.7,40.9l10.9,10.9l28.7-28.7"/>
                                  </svg>
                                  <h1 class="success-message__title">Appointment Status</h1>
                                  <div class="success-message__content">
                                      <p>Appointment request forwarded to the concern team, they will get back to you soon</p>
                                  </div>
                              </div>}
                          </div>
                      :null}
                        
                        <div className="clearfix" />
                      </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</>

    </div>
  );
}

export default Home;
